import { AuthReducerModal } from "../../store/slices/initialState";
import services from '../../Constant/service';
import endpoint from '../../Constant/endpoint';
import { createSlice, createAsyncThunk, isPending, isFulfilled, isRejected } from '@reduxjs/toolkit';
const initialState = new AuthReducerModal();

const superAdminSlice = createSlice({
  name: "superAdmin",
  initialState,
  reducers: {
    set: (state, action) => ({ ...state, ...action.payload }),
    loader: (state, action) => ({ ...state, isLoader: action.payload }),
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state) => ({ ...state, isLoader: true }))
      .addMatcher(isFulfilled, (state, action) => {
        const actionName = action.type.split('/')[1];
        const dynamicKey = `${actionName}Response`;
        return {
          ...state,
          isLoader: false,
          [dynamicKey]: action.payload
        };
      })
      .addMatcher(isRejected, (state) => ({ ...state, isLoader: false }));
  },
});
export const addEmployee = createAsyncThunk(
  'manageEmployee/addEmployee',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.manageEmployee.addEmployee,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getEmployeeList = createAsyncThunk(
  'manageEmployee/getEmployeeList',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.manageEmployee.getEmployeeList,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const uploadEmployeeFile = createAsyncThunk(
  'krakpi/uploadFile',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.superAdmin.manageEmployee.uploadEmplyeeFile,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getManagerList = createAsyncThunk(
  'manageEmployee/getManagerList',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.manageEmployee.getManagerList,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const addCompany = createAsyncThunk(
  'company/addCompany',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.company.addCompany,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getCompanyList = createAsyncThunk(
  'company/getCompanyList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.superAdmin.company.getCompanyList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const addDepartment = createAsyncThunk(
  'department/addDepartment',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.department.addDepartment,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getDepartmentList = createAsyncThunk(
  'department/getDepartmentList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.superAdmin.department.getDepartmentList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addSubDepartment = createAsyncThunk(
  'department/addSubDepartment',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.department.addSubDepartment,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getSubDepartmentList = createAsyncThunk(
  'department/getSubDepartmentList',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.superAdmin.department.getSubDepartmentList + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const updateDepartment = createAsyncThunk(
  'department/updateDepartment',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.superAdmin.department.updateDepartment + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const deleteDepartment = createAsyncThunk(
  'department/deleteDepartment',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.superAdmin.department.deleteDepartment + id, "",

        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },

      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateSubDepartment = createAsyncThunk(
  'department/updateSubDepartment',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.superAdmin.department.updateSubDepartment + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addUpdateKRAKPI = createAsyncThunk(
  'krakpi/addUpdateKRAKPI',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.krakpi.addUpdateKRAKPI,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },

      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const uploadFile = createAsyncThunk(
  'krakpi/uploadFile',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.superAdmin.krakpi.uploadFile,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSubDepartment = createAsyncThunk(
  'department/deleteSubDepartment',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.superAdmin.department.deleteSubDepartment + id, "",

        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },

      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addDesignation = createAsyncThunk(
  'designation/addDesignation',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.designation.addDesignation,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getDesignationList = createAsyncThunk(
  'designation/getDesignationList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.superAdmin.designation.getDesignationList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateDesignation = createAsyncThunk(
  'designation/updateDesignation',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.superAdmin.designation.updateDesignation + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const deleteDesignation = createAsyncThunk(
  'designation/deleteDesignation',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.superAdmin.designation.deleteDesignation + id, "",
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },

      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const uploadPolicyFile = createAsyncThunk(
  'policy/uploadPolicyFile',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.superAdmin.department.uploadPolicyFile,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addPolicy = createAsyncThunk(
  'policy/addPolicy',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.superAdmin.policy.addPolicy,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const { set, loader, reset } = superAdminSlice.actions;
export default superAdminSlice.reducer;